
import XHeader from 'vux/src/components/x-header/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import vuescroll from 'vuescroll'
import Error from '@/components/error'
import { mapState } from 'vuex'
export default {
name: 'notice',
props: [],
components: {
XHeader,
Badge,
Tab,
TabItem,
Swiper,
SwiperItem,
'scroller': vuescroll,
XButton,
Error
},
data () {
return {
title: this.$route.meta.title,
index: 0,
nTpye: 0,
meaaageNum: 0,
messageText: '',
messageInfo: '',
noticeType: '',
nTitleList: [],
noticeList: [],
fixedTop: 0,
errorMsg: {
type: 'null',
content: '暂无数据，请查看其他类型'
},
errorNotice: {
type: 'null',
content: '暂无通知消息'
},
isFirstLoad: true,
isNoMoreData: false,
current: 1,
totalPage: 0,
listNew: [],
scrollHeight: 0,
ops: {
vuescroll: {
mode: 'slide',
pullRefresh: {
enable: true,
tips: {
deactive: '下拉刷新',
active: '释放刷新',
start: '刷新中...',
beforeDeactive: '刷新成功!'
}
},
pushLoad: {
enable: true,
tips: {
deactive: '上拉加载',
active: '释放加载',
start: '加载中...',
beforeDeactive: '加载成功!'
}
}
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
}
}
},
computed: {
...mapState({
token: state => state.token
})
},
created () {
},
mounted () {
this.$vux.loading.show({
text: '加载中'
})
this.getNoticeTitle()
this.getMessage()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},

getNoticeTitle () {
this.$vux.loading.show({
text: '加载中'
})
let params = {}
params.status = 1
this.$api.get('/noticeType', params, r => {
this.$vux.loading.hide()
this.nTitleList = r.data
if (r.data.length > 0) {
this.noticeType = r.data[0].id
this.getNoticeList()
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

changeType (type) {
this.noticeType = type
this.isFirstLoad = true
this.isNoMoreData = false
this.current = 1
this.getNoticeList()
},

getNoticeList () {
let pageSize = 10
let params = {}
this.listNew = []
params.typeId = this.noticeType
params.isExpire = 1
params.isPublish = 1
params.pageSize = pageSize
params.current = this.current
this.$api.get('/notice/page', params, r => {
this.$vux.loading.hide()
this.totalPage = Math.ceil(r.data.totalCount / pageSize)
if (r.data.list.length > 0) {
this.listNew = r.data.list
}
if (this.isFirstLoad) {
this.noticeList = r.data.list
if (this.$refs['vs'] && r.data.list.length > 0) {
this.$refs['vs'].refresh()
}
}
this.getScrollHeight()
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getMessage () {
let params = {}
params.status = 0
params.isRead = 0
params.sendType = 0
this.$api.get('/message/info', params, r => {
this.$vux.loading.hide()
if (r.data.length > 0) {
this.messageText = r.data[0].content
this.messageInfo = r.data
this.meaaageNum = r.data.length
} else {
this.getMessageRead()
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getMessageRead () {
let params = {}
params.sendType = 0
params.status = 0
params.pageSize = 5
params.current = 1
this.$api.get('/message/info/page', params, r => {
this.$vux.loading.hide()
this.messageInfo = r.data.list
if (r.data.list.length > 0) {
this.messageText = r.data.list[0].messageBean.name
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
goNoticeDetail (id) {
this.$router.push({name: 'noticeDetail', params: { id: id }})
},
getScrollHeight () {
this.scrollHeight = document.documentElement.clientHeight - this.$refs.fixbox.offsetHeight - 53
},
handleRS (vsInstance, refreshDom, done) {
setTimeout(() => {
this.isFirstLoad = false
this.isNoMoreData = false
this.current = 1
this.getNoticeList()
done()
}, 1500)
},
handleLoadStart (vm, dom, done) {
setTimeout(() => {
this.isFirstLoad = false
if (this.current < this.totalPage) {
this.current = this.current + 1
this.getNoticeList()
this.ops.vuescroll.pushLoad.tips.beforeDeactive = '加载成功'
} else {
this.isNoMoreData = true
this.ops.vuescroll.pushLoad.tips.beforeDeactive = '没有更多数据了'
}
done()
}, 600)
},
handleLBD (vm, loadDom, done) {
setTimeout(() => {
if (!this.isNoMoreData) {
this.noticeList = this.noticeList.concat(this.listNew)
}
this.$refs['vs'].refresh()
done()
}, 500)
},
handleRBD (vm, loadDom, done) {
setTimeout(() => {
this.noticeList = []
this.noticeList = this.noticeList.concat(this.listNew)
this.$refs['vs'].refresh()
done()
}, 500)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/notice/notice.vue